export default {
  contact: 'Contact',
  credits: '© Mora. Tous droits réservés. :YEAR',
  designed_developed_by: 'Conception et développement web par <strong>Beet</strong>.',
  privacy_policy: 'Politique de confidentialité',
  your_email: 'Votre adresse courriel',
}
